// data/productsCategories.js
const productsCategories = [
    { id: 1, name: 'Проволока', path: '/produktsiya/wire' },
    { id: 2, name: 'Лента', path: '/produktsiya/tape' },
    { id: 3, name: 'Пруток', path: '/produktsiya/rod' }
]
export default productsCategories;